// extracted by mini-css-extract-plugin
export var gif = "_iu-0";